import React, { useEffect, useRef, useCallback, useState } from "react";
import Inputs from "../../components/Inputs/Inputs";
import axios from "axios";
import Table from "../../components/Table/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  handleDeleteButton,
  handleErrorState,
  handleLoadingSpinner,
  handleRemoveSearchExist,
  handleTableSkeleton,
  setSearchSelectOption,
} from "../../HandleSlice/HandleSlice";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { NavLink } from "react-router-dom";
import DeleteMultiModal from "../../components/DeleteMultiModal/DeleteMultiModal";
import DynamicPagesSkeleton from "../../components/DynamicPagesSkeleton/DynamicPagesSkeleton";
import { ToastContainer } from "react-toastify";
import Error from "../../components/Error/Error";
const DynamicPages = () => {
  const [deleteId, setDeleteId] = useState([]);
  const [isCheck, setIsCheck] = useState([]);
  const [data, setData] = useState([]);
  const [headerExist, setHeaderExist] = useState(false);
  const [multipopupDisplay, setMultiPopupDisplay] = useState(
    "invisible opacity-0",
  );
  const [filterOpened, setFilterOpened] = useState(true);
  const [inputData, setInputData] = useState({});
  const [searchParams, setSearchParams] = useSearchParams({});
  const [selectSearchData, setSelectSearchData] = useState({});
  const dataState = useSelector((state) => state.hamberger);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const locations = useLocation();
  const search = useLocation().search;
  const location = useParams().model;
  const pathname = useLocation();
  const filterContaner = useRef();
  const stateData = useSelector((state) => state.hamberger);
  let page = new URLSearchParams(search).get("page");
  let perPage = new URLSearchParams(search).get("per_page");

  const fetchInputsData = useCallback(() => {
    dispatch(handleErrorState(""));
    dispatch(handleTableSkeleton(true));
    if (pathname.search) {
      localStorage.setItem("queryParams", pathname.search);
    }
    axios
      .get(`/${location}${search}`, {
        params: {
          // page: `${page === null ? 1 : page}`,
          // per_page: `${perPage === null ? 10 : perPage}`,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .then(() => {
        dispatch(handleLoadingSpinner(false));
        dispatch(handleTableSkeleton(false));
      })
      .catch((e) => {
        console.error(e);
      });
  }, [dispatch, location, navigate, page, perPage, search]);

  useEffect(() => {
    fetchInputsData();
  }, [fetchInputsData]);

  const handleChange = (event) => {
    const urlParams = new URLSearchParams(window.location.search);
    if (+event.target.value === 10) {
      urlParams.delete("per_page");
    } else {
      urlParams.set("per_page", `${event.target.value}`);
    }
    navigate({ search: `${urlParams.toString()}` });
  };

  const nextPageHandler = (event) => {
    const urlParams = new URLSearchParams(window.location.search);
    if (
      +page < data.meta.last_page &&
      data.meta.last_page > data.meta.current_page
    ) {
      if (page === null) {
        urlParams.set("page", 2);
        navigate({ search: `${urlParams.toString()}` });
      } else {
        urlParams.set("page", `${+page + 1}`);
        navigate({ search: `${urlParams.toString()}` });
      }
    }
  };

  const prevPageHandler = (event) => {
    const urlParams = new URLSearchParams(window.location.search);
    if (+page > 2) {
      urlParams.set("page", `${+page - 1}`);
    }
    if (+page === 2) {
      urlParams.delete("page");
    }
    navigate({ search: `${urlParams.toString()}` });
  };

  const searchClickHandler = () => {
    const urlParams = new URLSearchParams(window.location.search);
    for (let key in inputData) {
      if (inputData[key] !== "") {
        urlParams.set(key, inputData[key]);
      } else {
        urlParams.delete(key);
      }
    }

    // delete page queryParams from url when search in page 2 or 3 or....
    urlParams.delete("page");
    navigate({ search: `${urlParams.toString()}` });
  };

  function removeSearch() {
    localStorage.removeItem("queryParams");
    navigate({ search: `` });
    let items = document.getElementsByClassName("serachInput");
    let items2 = document.getElementsByClassName("outline-none");
    dispatch(setSearchSelectOption(""));
    for (let item of items) {
      item.value = "";
    }
    for (let item of items2) {
      item.value = "";
    }
    let object = {};
    data.schema &&
      data.schema.search.forEach((item) => {
        object[item.key] = "";
      });
    setInputData(object);
    dispatch(handleRemoveSearchExist(false));
  }

  const pageChangeHandler = (event) => {
    setTimeout(() => {
      const pageValue = +event.target.innerText;
      if (isNaN(pageValue) || pageValue === 0 || event.key === "Enter") {
        event.target.innerText = "";
        return;
      } else if (pageValue > data.meta.last_page) {
        event.target.innerText = data.meta.last_page;
        return;
      }
    }, 1);
    setTimeout(() => {
      const pageValue = +event.target.innerText;
      const urlParams = new URLSearchParams(window.location.search);
      if (isNaN(pageValue) || pageValue === 0) {
        event.target.innerText = "";
        return;
      }
      if (+pageValue === 1) {
        urlParams.delete("page");
      } else {
        urlParams.set("page", `${pageValue}`);
      }
      navigate({ search: `${urlParams.toString()}` });
    }, 2000);
  };

  const pageOnblureHandler = (event) => {
    const pageValue = +event.target.innerText;
    const urlParams = new URLSearchParams(window.location.search);
    if (pageValue === 0 || pageValue === 1 || event.key === "Enter") {
      event.target.innerText = "1";
      urlParams.set("page", `1`);
      navigate({ search: `${urlParams.toString()}` });
    } else if (pageValue !== 0) {
      event.target.innerText = page;
    }
  };

  function handleKeyPress(e) {
    if (e.key === "Enter") {
      let object = inputData;
      setInputData(object);
      searchClickHandler();
    }
  }

  function searchButtonClickHandler(e) {
    let object = inputData;
    setInputData(object);
    searchClickHandler();
  }

  const deletClickHandler = () => {
    setMultiPopupDisplay("visible opacity-100");
    let idArray = [];
    for (let itemId of isCheck) {
      idArray.push(itemId);
    }
    dispatch(handleDeleteButton(idArray));
  };

  const paginationClickHandler = (event) => {
    event.target.innerText = "";
  };

  const chooseIdHandler = (deleteId) => {
    setDeleteId(deleteId);
  };

  function openFilter() {
    setFilterOpened(!filterOpened);
  }

  useEffect(() => {
    setHeaderExist(false);
    if (data.schema && data.schema.action.header.length > 0) {
      setHeaderExist(true);
    }
  }, [data, headerExist]);

  //make empty obj
  useEffect(() => {
    let object = {};
    data.schema &&
      data.schema.search.forEach((item) => {
        object[item.key] = "";
      });
    setInputData(object);
  }, []);

  // when change DynamicPage with dynamic rout setInputData have empty because urlParams not deleted
  useEffect(() => {
    setInputData({});
  }, [data]);

  useEffect(() => {
    if (pathname?.pathname === "/advertise") {
      localStorage.removeItem("expertId");
      localStorage.removeItem("expertItem");
    }
  }, []);

  //   useEffect(() => {
  //     setFilterOpened(false);
  //   }, [locations]);

  return (
    <>
      {dataState.errorState === 404 || dataState.errorState === 500 ? (
        <Error error={dataState.errorState} />
      ) : (
        ""
      )}
      {dataState.tableSkeleton ? (
        <DynamicPagesSkeleton />
      ) : (
        <div className="bg-body_background dark:bg-[#152A38] px-[14px] 900:pr-[25px] pr-[12px] mr-0 w-[calc(100%)] 900:mr-[248px] 900:w-[calc(100%-248px)] transition-all pb-5 pt-[90px]">
          <div className="flex justify-between items-center">
            <h1 className="text-[#170c6b] text-[18px] dark:text-white">
              {data.schema && data.schema.tabs}
            </h1>
            <button
              className="flex items-center gap-x-[8px] p-1 rounded-md border-2 border-gray-300 px-[20px] py-[8px]"
              onClick={openFilter}
            >
              <span className="dark:text-gray-300 inline-block text-gray-500">
                فیلتر
              </span>
              {/*<RiFilterFill className="text-[18px] dark:text-gray-300"/>*/}
              <i className="fa fa-filter text-[44px] dark:text-gray-300 text-aside_background"></i>
            </button>
          </div>
          <div
            className={`bg-component_background w-full px-[25px] rounded-xl dark:bg-[#29435C] transition-all duration-700 mt-[10px]`}
            ref={filterContaner}
            style={
              filterOpened
                ? {
                    height:
                      filterContaner.current &&
                      filterContaner.current.scrollHeight,
                  }
                : { height: "0px" }
            }
          >
            <h3 className="font-semibold text-[14px] dark:text-[#e8ebe0] mt-[10px]">
              جستجو
            </h3>
            <div className="grid grid:cols-1 560:grid-cols-2 lg:grid-cols-3 gap-y-4 mt-[16px] items-start gap-x-6 ">
              {data.schema &&
                data.schema.search.map((item, index) => (
                  <Inputs
                    item={item}
                    key={item.key}
                    pageType={"search"}
                    setSearchParams={setSearchParams}
                    dataState={dataState.singleKey}
                    searchParams={searchParams}
                    inputData={inputData}
                    setInputData={setInputData}
                    handleKeyPress={handleKeyPress}
                    searchClickHandler={searchClickHandler}
                    fetchInputsData={fetchInputsData}
                    setSelectSearchData={setSelectSearchData}
                    selectSearchData={selectSearchData}
                    matchpointId={"matchpoint" + index}
                    id={`${item.controlType}-${index}`}
                  />
                ))}
            </div>

            <div className="flex justify-center 320:justify-end gap-x-5 mt-5">
              <button
                type="button"
                onClick={searchButtonClickHandler}
                className={
                  " w-[80px] 560:w-[120px] text-center h-[38px] rounded-[3px] bg-confirm_button_background text-confirm_button_text hover:bg-confirm_button_background_hover border border-confirm_button_border text-[12px] 560:text-[16px] mb-[10px]"
                }
              >
                جستجو
              </button>
              {stateData.removeSearchExist && (
                <button
                  className={
                    "w-[80px] 560:w-[120px] text-center h-[38px] rounded-[3px] border border-cancel_button_border bg-cancel_button_background text-cancel_button_text hover:bg-cancel_button_background_hover dark:bg-[#ff8992] dark:text-white dark:hover:bg-[#fd727d]"
                  }
                >
                  <span
                    className=" text-[12px] 560:text-[16px]"
                    onClick={removeSearch}
                  >
                    حذف جستجو
                  </span>
                </button>
              )}
            </div>
          </div>
          <div className="bg-component_background w-full p-[25px] rounded-xl mt-[16px] dark:bg-[#29435C]">
            <div className="flex flex-col 320:flex-row-reverse 320:justify-between pr-2 gap-y-2">
              <div className="flex gap-4">
                {headerExist &&
                  data.schema &&
                  data.schema.action.header.map((item, index) => (
                    <NavLink
                      key={index}
                      to={`${locations.pathname}/create${
                        item.parameters
                          ? item.parameters.map(
                              (param) =>
                                "?" +
                                Object.keys(param) +
                                "=" +
                                param[Object.keys(param)] +
                                "&",
                            )
                          : ""
                      }`}
                    >
                      <button className="px-2 text-center h-[38px] rounded-md bg-info_button_background dark:bg-[#ffffffaa] dark:hover:bg-[#ffffffdd] border text-info_button_text border-info_button_border hover:bg-info_button_background_hover items-center flex gap-1 text-[12px] 560:text-[16px]">
                        {item && item.label}
                        <i className={`fa fa-${item && item.icon}`}></i>
                      </button>
                    </NavLink>
                  ))}
              </div>
              {dataState.DeleteButtonDisplayState && (
                <button
                  type="button"
                  className="w-[60px] 560:w-[120px] h-[38px] border dark:border-none dark:bg-red-500 dark:text-white border-red-600 rounded-md text-red-600 hover:bg-red-50 text-[12px] 560:text-[16px] flex items-center justify-center gap-x-2"
                  onClick={deletClickHandler}
                >
                  <i className="fa fa-trash pb-1"></i>
                  <span className="text-[12px] 560:text-[16px]">حذف</span>
                </button>
              )}
            </div>
            <div className="w-full mt-2 320:mt-5 overflow-x-scroll 1200:overflow-x-hidden table_scrollbar min-h-[250px] rounded-t-xl">
              <Table
                data={data}
                location={location}
                fetchInputsData={fetchInputsData}
                chooseIdHandler={chooseIdHandler}
                isCheck={isCheck}
                setIsCheck={setIsCheck}
                page={page}
                perPage={perPage}
              />
            </div>
            <div className="w-full mt-5 border py-5 border-pagination_border gap-y-5 560:gap-y-3 grid grid-cols-1 560:grid-cols-2 md:flex sm:justify-around items-center m-auto text-center bg-pagination_background text-pagination_text dark:bg-[#29435C] rounded-b-xl dark:text-[#e8ebe0]">
              <div className="flex items-center justify-between md:w-[25%] w-[190px] 560:w-[70%] m-auto md:m-0">
                <button
                  className="fa fa-angle-double-right py-2 px-3 rounded-full dark:hover:bg-slate-500 hover:bg-slate-300"
                  onClick={prevPageHandler}
                ></button>
                <div>صفحه : {page === null ? 1 : page}</div>
                <button
                  className="fa fa-angle-double-left py-2 px-3 rounded-full dark:hover:bg-slate-500 hover:bg-slate-300"
                  onClick={nextPageHandler}
                ></button>
              </div>
              <div className="flex items-center 320:w-[245px] w-[135px] m-auto md:m-0">
                <span className="hidden 320:inline-block">
                  انتخاب صفحه : &nbsp;
                </span>
                <span className="min-w-[50px] h-[30px] flex justify-around items-center text-center bg-stone-300 rounded-md dark:bg-[#5a646f] px-2 gap-2">
                  <span
                    contentEditable="true"
                    suppressContentEditableWarning={true}
                    className="cursor-cell min-w-[30px] h-[30px] flex justify-center items-center focus:bg-white dark:bg-[#5a646f]"
                    onKeyDown={pageChangeHandler}
                    onClick={paginationClickHandler}
                    onBlur={pageOnblureHandler}
                  >
                    {data.meta === undefined
                      ? ""
                      : page === null
                        ? 1
                        : page > data.meta.last_page
                          ? data.meta.last_page
                          : page}
                  </span>
                  <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                </span>
                &nbsp; از &nbsp;
                {data.meta && data.meta.last_page}
                &nbsp;
              </div>
              <div>تعداد : {data.meta && data.meta.total}</div>
              <div>
                تعداد نمایش :
                <select
                  value={
                    perPage === null ? data.meta && data.meta.per_page : perPage
                  }
                  onChange={handleChange}
                  className="bg-white dark:bg-[#29435C] rounded-md"
                >
                  {data.meta &&
                    data.meta.pages.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      )}
      <DeleteMultiModal
        setMultiPopupDisplay={setMultiPopupDisplay}
        multipopupDisplay={multipopupDisplay}
        deleteId={deleteId}
        setDeleteId={setDeleteId}
        setIsCheck={setIsCheck}
        location={location}
        fetchInputsData={fetchInputsData}
        data={data.data}
      />
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};
export default React.memo(DynamicPages);
